import type {
  DocEntityHandle,
  IsolatableEntityHandle,
  IsolatableEntityType,
} from "building-types/handles/docEntityHandleTypes";
import { objectTypedKeys } from "common/utils/objectTypedKeys";

const isolatableEntityTypeMap: { [key in IsolatableEntityType]: boolean } = {
  COMPONENT: true,
};

export const isolatableEntityTypes = objectTypedKeys(isolatableEntityTypeMap);

export function docEntityIsIsolatable(handle: DocEntityHandle): handle is IsolatableEntityHandle {
  return handle.type in isolatableEntityTypeMap;
}
